import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { AdjustmentRuleAction } from './adjustmentRule.action';
import { adjustmentRuleInitialState } from './adjustmentRule.constant';

export const adjustmentRuleReducer = reducerWithInitialState(adjustmentRuleInitialState)
  .case(AdjustmentRuleAction.loadList.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(AdjustmentRuleAction.loadList.done, (state, payload) => {
    return {
      ...state,
      list: payload.result,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(AdjustmentRuleAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(AdjustmentRuleAction.destroy, () => ({
    ...adjustmentRuleInitialState,
  }));
